import Vue from "vue";
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado";

let valorFixoPromise = null;

function valorVazio(valor) {
  if (valor === null || valor === undefined || valor === "") {
    return true;
  }
  const numero =
    typeof valor === "number"
      ? valor
      : Number(
          String(valor)
            .replace(/[^\d,.-]/g, "")
            .replace(/\./g, "")
            .replace(",", ".")
        );
  return !numero;
}

export default {
  buscarValorFixo() {
    if (valorFixoPromise === null) {
      const usuarioLogado = usuarioHelper.USUARIO_LOGADO();
      if (!usuarioLogado) {
        return Promise.resolve(null);
      }
      valorFixoPromise = axios
        .get(`${process.env.URL_CALCULOMS}/v1/limitesTaxasBasicas`, {
          headers: {
            Authorization: `Bearer ${usuarioLogado.token}`
          }
        })
        .then(resposta => {
          const valor = resposta.data
            ? resposta.data.valorFixoDespesasExtras
            : null;
          return valor === null || valor === undefined ? null : Number(valor);
        })
        .catch(() => {
          valorFixoPromise = null;
          return null;
        });
    }
    return valorFixoPromise;
  },

  aplicarValorFixo(itens, valorFixo) {
    if (valorFixo === null || valorFixo === undefined) {
      return;
    }
    const lista = itens instanceof Array ? itens : [itens];
    lista.forEach(item => {
      if (
        item &&
        item.coberturaAdicionalDespesasExtras &&
        valorVazio(item.despesasExtras)
      ) {
        Vue.set(item, "despesasExtras", Number(valorFixo));
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/helpers/despesas-extras.js